/**
 * Class to authorize with server
 *
 * @author Michel Heitbrink
 */
//const openpgp = require('openpgp/dist/openpgp.min.js');
//const cryptojs = require('crypto-js');

import ServerRequest from './ServerRequest';

class Encryption {

	constructor( options ) {

        this.publicKey = null;
        this.sid = null;

		this.methods = {
			connect: 'connect',
            authorize: 'authorize',
            logoff: 'logoff',
            loggedIn: 'loggedIn'
		};

        if ( options && options.methods ) {
            this.methods = Object.assign(this.methods, options.methods);
        }

		this.options =  options;
		this.options.methods = this.methods;
	}

    /**
	 * Get public keys of server for encryption.
	 * @return {Promise}
	 */
	connect() {
        const request = new ServerRequest(this.options);
		return request.post( this.methods.connect || 'connect' , null, { encrypt: false } );
	}

    /**
     * Return publicKey and sid
     */
    getPublicKey() {

        return new Promise( ( resolve, reject ) => {

            if ( this.publicKey && this.sid ) {
                resolve( { publicKey: this.publicKey, sid: this.sid });
            } else {

                this.connect().then( ( {result, status} ) => {

                    this.publicKey = result.pkey;
                    this.sid = result.sid;

                    resolve( { publicKey: this.publicKey, sid: this.sid } );

                }).catch(reject);
            }
        });
    }

	/**
	 * Encrypt payload with given public keys.
	 * @param  {Message} payload
	 * @param  {PublicKey} publicKeys
	 * @return {Promise}
	 */
	encrypt( payload ) {

		return new Promise( ( resolve, reject ) => {

            this.getKeys().then( ( publicKeys ) => {

                if ( publicKeys.err && publicKeys.err.length > 0 ) {
                    reject( publicKeys.err[0] );
                }
                else {

					if ( typeof payload == 'object' ) {
						payload = JSON.stringify(payload);
					}

                    openpgp.encrypt( { message: openpgp.message.fromText(payload), publicKeys: publicKeys.keys } ).then( ( result ) => {

                        resolve( result.data );

                    }).catch( ( error ) => {

                        reject( error );

                    });
                }
            });

		});
	}

	/**
	 * Converts server keys to OpenPGP PublicKey.
	 * @param  {String} pkey
	 * @return {Promise}
	 */
	getKeys() {

		return new Promise( ( resolve, reject ) => {

            this.getPublicKey().then( ( data ) => {

                openpgp.key.readArmored( atob( data.publicKey ) ).then( ( publicKeys ) => {

    				resolve(publicKeys);

    			}).catch( ( error ) => {

    				reject( error );

    			});

            }).catch(reject);
		});
	}

}

export default Encryption;

/*
---
name: Encryption
category: JavaScript
---
Helper class to encrypt data with gpg

Examples
======

```js
const encryption = new Encryption( options );
encryption.encrypt({ example: 'test' }).then( ( encrypted ) => {
    //do something
});
```

*/
